var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24M16 25V6M8 15.252C8 22.939 14.918 25.639 15.887 25.98C15.9623 26.0067 16.0377 26.0067 16.113 25.98C17.084 25.65 24 23.018 24 15.253V8.304C24.0002 8.21463 23.9705 8.12777 23.9156 8.05726C23.8607 7.98675 23.7837 7.93667 23.697 7.915L16.097 6.012C16.0333 5.99608 15.9667 5.99608 15.903 6.012L8.303 7.915C8.2163 7.93667 8.13935 7.98675 8.08443 8.05726C8.02952 8.12777 7.99979 8.21463 8 8.304V15.252Z",
    stroke: "#4A5568",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.8ff83359253f6b489085bb3d9859b1b4.svg";
export { ForwardRef as ReactComponent };